<template>
  <!-- <div :class="[multipage === true ? 'multi-page' : 'single-page', 'home-page']">
		<div style="width:100%;height:700px;">
			<a-tabs type="card" default-active-key="1" :animated="true" size="large" :tabBarGutter="20" :tabBarStyle="{}" @tabClick="tabClick">
				<a-tab-pane key="1" tab="投保统计图"><home-page1></home-page1></a-tab-pane>
				<a-tab-pane key="2" tab="理赔统计图"><home-page2></home-page2></a-tab-pane>
			</a-tabs>
		</div>
	</div> -->
  <!-- <div>
		<div style="text-align: center;margin-left:-20px;margin-right:-20px;height:100%;overflow:hidden;position: relative;">
			<img src="../assets/images/theme-img/homepageBgc.png"  style="width:100%"/>
		</div>
		<div class="modelImg">
			<img src="../assets/images/theme-img/homePage1.png" @click="goRoute1"/>

			<img src="../assets/images/theme-img/homePage3.png" @click="goRoute3"/>
      <img src="../assets/images/theme-img/homePage2.png" @click="goRoute2"/>
		</div>
	</div> -->

  <div class="home-container">
    <img :src="imgUrl" alt="" />
  </div>
</template>
<script>
// import moment from 'moment'
import { mapState } from 'vuex'
// import HomePage1 from './HomePage1'
// import HomePage2 from './HomePage2'
// import $ from 'jquery'
// // import bus from './common/bus.js';
// import db from 'utils/localstorage'
// moment.locale('zh-cn')
// import imgUrl from '../assets/images/theme-img/homepageBgc.png'
export default {
  name: "HomePage",
  data() {
    return {
      // imgUrl
      imgList: {
        0: require("../assets/images/theme-img/homePage3.png"), // 省级 （默认）
        3: require("../assets/images/theme-img/homePage2.png"), // 县级
        5: require("../assets/images/theme-img/homePage1.png"), // 村级
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.account.user,
    }),


    imgUrl() {
      let imgUrl = this.imgList[this.user.level] || this.imgList[0];

      return imgUrl;
    },
  },
  methods: {
    goRoute1() {
      // 种植台账管理系统
      this.$router.push("/themePage/plant");
    },
    goRoute2() {
      // 农业补贴管理系统
      this.$router.push("/themePage/subsidyTheme");
    },
    goRoute3() {
      // 农业保险管理系统
      this.$router.push("/themePage/agriculture");
    },
  },
};
</script>
<style lang="less" scoped>
.home-container {
  width: 100%;
  height: calc(100vh - 64px);
  overflow: hidden;
  img {
    display: block;
    width: 100%;
  }
}
// .modelImg {
// 	width: 50%;
// 	height: 300px;
// 	margin: 0 auto;
// 	position: absolute;
// 	top: 50%;
// 	left: 0;
// 	right: 0;
// 	bottom: 0;
// 	img {
// 		width: 20%;
// 		// height: 100%;
// 		margin: 0 6%;
// 		transition: all 0.6s;
// 		cursor: pointer;
// 	}
// 	img:hover {
// 		transform: scale(1.2); //设置图片按照比例放大1.2倍
// 	}
// }
// /deep/body {
// 	overflow: hidden;
// }
// /deep/ .ant-tabs.ant-tabs-card > .ant-tabs-bar {
// 	font-size: 16px;
// }
// /deep/ .ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
// 	background: #42b983;
// 	border-color: #e8e8e8;
// 	font-weight: bold;
// 	color: #fff;
// }
// :global {
// 	.fixed-header-content {
// 		margin: 0px !important;
// 	}
// 	.ant-layout-content {
// 		margin: 0px !important;
// 	}
// }
// /deep/.ant-layout-content {
// 	margin: 0px !important;
//   overflow-y: auto;
// }
// .bgc_color {
// 	// background: linear-gradient(217deg, #0578cb, #002074 70.71%);
// 	// background: radial-gradient(#0578cb 10px, #002074 80%, #002074 50%);
// 	background: #000;
// 	overflow: hidden;
// 	position: relative;
// }

// // 动画悬停效果
// .main_box {
// 	height: 200px;
// 	width: 100%;
// 	position: absolute;
// 	// position: fixed;
// 	// top: 300px;
// }
// .bannerImg {
// 	width: 60%;
// 	position: absolute;
// 	top: 0;
// 	left: 0;
// 	right: 0;
// 	bottom: 0;
// 	margin: 150px auto;
// }
// .box {
// 	position: absolute;
// 	top: 1100px;
// 	left: 0;
// 	right: 0;
// 	bottom: 0;
// 	margin: auto;
// 	height: 200px;
// 	width: 1100px;
// }
// .box_ul_li {
// 	width: 280px;
// 	height: 200px;
// 	border-radius: 20px;
// 	// box-shadow: 3px 2px 30px rgba(0, 0, 0, 0.1);
// 	float: left;
// 	text-align: center;
// 	position: relative;
// 	transition: all 0.6s ease-out;
// 	margin-left: 50px;
// 	// background: rgba(255, 255, 255, 0.2);
// }
// ul li {
// 	list-style-type: none;
// }
// .box ul li h3 {
// 	padding-top: 30px;
// 	color: #333;
// 	font-size: 18px;
// }
// .box ul li p {
// 	margin-top: 7px;
// 	color: #666;
// 	font-size: 14px;
// }
// .box ul li img {
// 	width: 100%;
// 	position: absolute;
// 	right: 26px;
// 	bottom: 40px;
// 	transition: all 0.6s ease-out;
// }
// .box ul .on {
// 	// background-color: #6ab0e8;
// 	// background: rgba(255, 255, 255, 0.2);
// 	// text-align: left;
// 	transform: scale(1.2);
// }
// .box ul .on h3 {
// 	padding-left: 20px;
// 	color: #fff;
// }
// .box ul .on p {
// 	margin-left: 20px;
// 	color: #fff;
// }
// .box ul .on img {
// 	width: 382px;
// 	position: absolute;
// 	right: 8px;
// 	bottom: 10px;
// 	border: 2px #3e3d3d solid;
// }

// * {
// 	margin: 0px;
// 	padding: 0px;
// }
// body {
// }
// /* .cs{
// 		width: 300px;
// 		height: 300px;
// 		background: #ffffff;
// 		margin: 0 auto;
// 		position: absolute;
// 		top: 50%;
// 		left: 50%;
// 		margin: -200px 0 0 -150px;
// 	} */
// .canvasSky {
// 	position: absolute;
// 	margin-left: -15px;
// 	// z-index: -1;
// }
</style>



// WEBPACK FOOTER //
// src/views/HomePage.vue